import { render, staticRenderFns } from "./Qxc.vue?vue&type=template&id=5b6cf9c0&scoped=true"
import script from "./Qxc.vue?vue&type=script&lang=js"
export * from "./Qxc.vue?vue&type=script&lang=js"
import style0 from "./Qxc.vue?vue&type=style&index=0&id=5b6cf9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6cf9c0",
  null
  
)

export default component.exports